import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "@/components/layout/Sidebar";
import TopBar from "@/components/layout/TopBar";
import { th as palette } from "@/lib/bricks";
import { useShellDark } from "@/lib/useShellDark";

export default function DashboardLayout() {
  const dark = useShellDark();
  const p = palette(dark);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  // Close the drawer on any route change (back/forward included) and on Escape.
  useEffect(() => { setSidebarOpen(false); }, [location.pathname]);
  useEffect(() => {
    if (!sidebarOpen) return undefined;
    const onKey = (e) => { if (e.key === "Escape") setSidebarOpen(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [sidebarOpen]);

  return (
    <div
      className="flex h-dvh max-h-dvh overflow-hidden"
      style={{ background: p.bg, color: p.ink }}
      data-testid="dashboard-layout"
    >
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/50 lg:hidden"
          aria-hidden="true"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <div
        className={`fixed inset-y-0 left-0 z-50 h-dvh max-h-dvh transition-transform duration-200 ease-in-out lg:static lg:h-auto lg:max-h-none lg:translate-x-0 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full max-lg:invisible'}`}
        style={{ transitionProperty: 'transform, visibility' }}
      >
        <Sidebar onNavigate={() => setSidebarOpen(false)} />
      </div>

      <div className="flex flex-1 flex-col overflow-hidden min-w-0">
        <TopBar onOpenSidebar={() => setSidebarOpen(true)} />
        <main className="flex-1 min-h-0 overflow-y-auto px-5 py-6 pb-[max(1.5rem,env(safe-area-inset-bottom))] md:px-9 md:py-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
